/**
 * Main application entry point.
 */

'use strict';

var app = require('mag-app');


require('./modules/player-debugger');
require('cjs-polyfills/lib/array.find.index');

// main application events
app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language || 'en'}, function ( error ) {
        var env = require('./modules/environment');

        if ( error ) {
            console.log(error);
            console.log('ERROR LOADING LANGUAGE!!!!!!!!!!!!!!!!');
        }
        console.log('===========================================', '');
        console.log('SYSTEM PLAYER START', '');

        try {
            console.log(JSON.stringify(env));
        } catch ( error ) {
            console.log(error);
            console.log('wrong environment init');
        }

        if ( core.device ) {
            document.body.setAttribute('device', core.device.model);
        }

        console.log('===========================================', '');

        app.timeshift = core.plugins.timeshift || false;

        app.config.pipSupport = require('./modules/tools').detectPipSupport();

        app.pages = {
            main: require('./pages/main'),
            clear: require('./pages/clear'),
            settings: require('./pages/settings'),
            advertising: require('./pages/advertising')
        };

        // go to the main page when necessary
        app.route(app.pages.main);
        app.playerPanel.focus();
    });
});
